// @ts-nocheck
export const selectPendingActions = state => state.pending.pendingActions;
